const ContactName = (props) => {
  return (
    <>
      <h6>{props.name}</h6>
    </>
  );
};

export default ContactName;
